export const ATTRIBUTE_RULES_TOOLTIP =
  'Customise the product name, image, description and POS ID for each downstream channel.';

export const NO_DESTINATIONS_MESSAGE =
  "This rule has no channels or venues, so it won't be published anywhere. Edit its destinations to choose where it applies.";

export const NO_CHANNELS_MESSAGE = 'This rule has no channels.';

export const NO_VENUES_MESSAGE = 'This rule has no venues.';
